import {Action, Dispatch} from 'redux';
import {ApiActionCall, ApiActionTypes} from '../Api';
import {logger} from '../../../shared/logger';
import {showError} from '../Common';
import {EXCHANGES_URL} from '../../../@crema/services/ApiConfig';
import {
  FETCH_REPORT_DATA,
  FETCH_REPORT_DATA_ERROR,
  FETCH_REPORT_DATA_SUCCESS,
  ReportPeriod,
  ReportsActionTypes,
} from '../../../types/actions/Exchanges/Reports.action';
import {
  IReportMonthly,
  IReportYearly,
  IReportWeekly,
} from '../../../types/models/Reports';

export const fetchReports = (slug: string, period: ReportPeriod) => async (
  dispatch: Dispatch<ApiActionCall | ReportsActionTypes>,
) => {
  dispatch({type: FETCH_REPORT_DATA});

  const onSuccess = (
    data: IReportYearly[] | IReportMonthly[] | IReportWeekly[],
  ) => ({
    type: FETCH_REPORT_DATA_SUCCESS,
    payload: {slug, period, data},
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_REPORT_DATA_ERROR});
    dispatch(showError('Failed to fetch Report data.'));
  };

  const getPeriodUrl = () => {
    switch (period) {
      case ReportPeriod.YEARLY:
        return EXCHANGES_URL + '/' + slug + '/reports/yearly';
      case ReportPeriod.MONTHLY:
        return EXCHANGES_URL + '/' + slug + '/reports/monthly';
      case ReportPeriod.WEEKLY:
        return EXCHANGES_URL + '/' + slug + '/reports/weekly';
      default:
        return EXCHANGES_URL + '/' + slug + '/reports/yearly';
    }
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: getPeriodUrl(),
      method: 'GET',
      label: 'Fetch Report data',
      onSuccess,
      onFailure,
    },
  });
};
